<template>
    <div>
        <el-page-header class="page-header" @back="goBack" content="待结算明细"></el-page-header>
        <!-- <div class="page-header">
            <div class="line"></div>
            <div class="page-title">待结算明细</div>
        </div> -->
        <!-- 财务概览卡片 -->
        <div class="financial-overview">
            <div class="overview-card">
                <div class="card-content">
                    <div class="card-amount">{{ FinancialData.wait_settle_order }}</div>
                    <div class="card-title">待结算 (元)</div>
                    <div class="withdraw-btn">《平台抽佣规则》</div>
                </div>
            </div>
            <div class="overview-card">
                <div class="card-content">
                    <div class="card-amount">{{ FinancialData.riing_settle_order }}</div>
                    <div class="card-title">进行中 (元)</div>
                </div>
            </div>
            <div class="overview-card">
                <div class="card-content">
                    <div class="card-amount">{{ FinancialData.settle_order }}</div>
                    <div class="card-title">已结算（元）</div>
                </div>
            </div>
        </div>

        <!-- 筛选区域 -->
        <div class="filter-section">
            <div class="filter-title">待结算明细</div>
            <!-- 时间筛选 -->
            <el-form inline :model="searchForm" class="form_class">
                <el-form-item label="结算状态">
                    <el-select size="small" v-model="searchForm.status" placeholder="请选择结算状态">
                        <el-option v-for="item in settleStatusOptions" :key="item.value" :label="item.name"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="结算时间">
                    <el-date-picker size="small" v-model="searchForm.time" type="daterange" value-format="yyyy-MM-dd"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="resetForm">重置</el-button>
                    <el-button size="small" type="primary" @click="getCgdtMoneyList">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 明细表格 -->
        <el-table :data="financialList" :border="true" style="width: 100%;margin-bottom: 20px;">
            <el-table-column prop="order_sn" label="订单号" align="center">
            </el-table-column>
            <el-table-column prop="refund_money" label="店铺退款金额（元）" align="center">
            </el-table-column>
            <el-table-column prop="platform_money" label="平台抽成（元）" align="center">
            </el-table-column>
            <el-table-column prop="store_money" label="店铺金额（元）" align="center"></el-table-column>
            <el-table-column prop="settle_time" label="完成时间" align="center"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize" :current-page="currentPage" @size-change="handleSizeChange"
            @current-change="handleCurrentChange"></el-pagination>
    </div>
</template>

<script>
export default {
    name: 'Settlement',
    data() {
        return {
            searchForm: {
                status: '0',
                time: [],
            },
            settleStatusOptions: [{
                name: '全部',
                value: '0',
            }, {
                name: '待结算订单',
                value: '1',
            }, {
                name: '进行中订单',
                value: '2',
            }, {
                name: '已结算订单',
                value: '3',
            }],
            financialList: [],// 财务明细数据
            total: 0,// 总条数
            currentPage: 1,// 当前页码
            pageSize: 10,// 每页条数
            FinancialData: {
                ring_settle_order: 0,
                settle_order: 0,
                wait_settle_order: 0,
            },// 财务统计数据
        }
    },
    mounted() {
        this.getCgdtMoneyAll();
        this.getCgdtMoneyList();
    },
    methods: {
        goBack() {
            this.$emit('goToComponent', 'FinancialHome');
        },
        // 重置表单
        resetForm() {
            this.searchForm = {
                status: '0',
                time: [],
            };
            this.getCgdtMoneyList();
        },
        // 获取财务统计数据
        getCgdtMoneyAll() {
            this.$api.getCgdtMoneyAll().then(res => {
                this.FinancialData = res;
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 获取金额明细列表
        getCgdtMoneyList() {
            this.$api.getCgdtMoneyList({
                order_status: this.searchForm.status,
                start_time: this.searchForm.time[0],
                end_time: this.searchForm.time[1],
                page: this.currentPage,
                list_rows: this.pageSize,
            }).then(res => {
                this.financialList = res.data;
                this.total = res.total
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 分页相关
        handleSizeChange(val) {
            this.pageSize = val;
            this.getCgdtMoneyList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getCgdtMoneyList();
        }
    }
}
</script>

<style scoped>
.financial-management {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: calc(100vh - 120px);
}

.page-header {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
}

.page-header .line {
    width: 4px;
    height: 20px;
    background-color: #286ced;
    margin-right: 12px;
}

.page-header .page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

/* 财务概览卡片 */
.financial-overview {
    display: flex;
    gap: 20px;
    margin-bottom: 24px;
}

.overview-card {
    flex: 1;
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    position: relative;
}

.card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.card-title {
    font-size: 14px;
    color: #666;
    margin-top: 16px;
}

.card-amount {
    font-size: 32px;
    font-weight: 700;
    color: #333;
}

.withdraw-btn {
    position: absolute;
    top: 10px;
    right: 0;
    font-weight: 500;
    font-size: 14px;
    color: #153674;
    cursor: pointer;
}

.detail-btn {
    width: 40px;
    height: 20px;
    background: #FFFFFF;
    border-radius: 10px 10px 10px 0px;
    border: 1px solid #BFBFBF;
    position: absolute;
    top: 0;
    right: 0;
    font-weight: 500;
    font-size: 12px;
    color: #BFBFBF;
    cursor: pointer;
}

/* 筛选区域 */
.filter-section {
    background-color: #fff;
    border-radius: 8px;
}

.filter-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    text-align: left;
}

.time-filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

/* 表格样式 */
::v-deep .el-table__header-wrapper th {
    background-color: #f5f7fa;
    font-weight: 600;
    color: #666;
    font-size: 14px;
    border-bottom: 1px solid #ebeef5;
}

::v-deep .el-table__body-wrapper td {
    font-size: 14px;
    color: #333;
    border-bottom: 1px solid #ebeef5;
}

/* 类型样式 */
.expense-type,
.withdraw-status {
    color: #f56c6c;
}

.income-type,
.settle-status {
    color: #67c23a;
}

.expense-amount {
    color: #f56c6c;
    font-weight: 500;
}

.income-amount {
    color: #67c23a;
    font-weight: 500;
}
.form_class{
    text-align: left;
    display: flex;
    align-items: center;
    gap: 16px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .financial-overview {
        flex-direction: column;
    }

    .time-filter {
        flex-wrap: wrap;
        gap: 16px;
    }

    .type-filter {
        justify-content: flex-start;
    }
}
</style>